import React, { useEffect, useState, createElement } from 'react';
import { TrendingUp, User, X, Lock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
declare global {
  interface Window {
    Tally?: {
      openPopup: (formId: string, options?: Record<string, any>) => void;
      closePopup: (formId: string) => void;
    };
  }
}
const EARLY_ACCESS_URL = 'https://register.gocaveo.com';
const USER_PASSWORD = 'learnpasswordcreationin2026!';
const INVESTOR_PASSWORD = 'CrowdStrike4Consumers!';
function PasswordModal({
  isOpen,
  onClose,
  onSubmit,
  title,
  description,
  icon,
  error,
  password,
  onPasswordChange
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  title: string;
  description: string;
  icon: React.ReactNode;
  error: string;
  password: string;
  onPasswordChange: (val: string) => void;
}) {
  if (!isOpen) return null;
  return <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '24px'
  }} onClick={onClose} data-id="element-871">
      <div style={{
      backgroundColor: '#fff',
      borderRadius: '16px',
      padding: '32px',
      maxWidth: '384px',
      width: '100%',
      position: 'relative',
      boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)'
    }} onClick={e => e.stopPropagation()} data-id="element-872">
        <button type="button" onClick={onClose} style={{
        position: 'absolute',
        top: '16px',
        right: '16px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#9ca3af',
        padding: '4px'
      }} data-id="element-873">
          <X size={20} data-id="element-874" />
        </button>

        <div style={{
        textAlign: 'center',
        marginBottom: '24px'
      }} data-id="element-875">
          <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: 'rgba(99,27,183,0.1)',
          borderRadius: '50%',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '16px'
        }} data-id="element-876">
            {icon}
          </div>
          <h2 style={{
          fontSize: '20px',
          fontWeight: 700,
          color: '#111',
          margin: '0 0 8px 0'
        }} data-id="element-877">
            {title}
          </h2>
          <p style={{
          fontSize: '14px',
          color: '#6b7280',
          margin: 0
        }} data-id="element-878">
            {description}
          </p>
        </div>

        <form onSubmit={onSubmit} data-id="element-879">
          <input type="password" value={password} onChange={e => onPasswordChange(e.target.value)} placeholder="Enter password" autoFocus style={{
          width: '100%',
          padding: '12px 16px',
          border: '2px solid #e5e7eb',
          borderRadius: '8px',
          fontSize: '16px',
          outline: 'none',
          marginBottom: '12px',
          boxSizing: 'border-box'
        }} data-id="element-880" />
          {error && <p style={{
          color: '#ef4444',
          fontSize: '14px',
          marginBottom: '12px',
          marginTop: 0
        }} data-id="element-881">
              {error}
            </p>}
          <button type="submit" style={{
          width: '100%',
          backgroundColor: '#631bb7',
          color: '#fff',
          padding: '12px',
          borderRadius: '8px',
          fontWeight: 700,
          fontSize: '16px',
          border: 'none',
          cursor: 'pointer'
        }} data-id="element-882">
            Log In
          </button>
        </form>
      </div>
    </div>;
}
export function ComingSoonPage() {
  const navigate = useNavigate();
  const [userModal, setUserModal] = useState(false);
  const [userPassword, setUserPassword] = useState('');
  const [userError, setUserError] = useState('');
  const [investorModal, setInvestorModal] = useState(false);
  const [investorPassword, setInvestorPassword] = useState('');
  const [investorError, setInvestorError] = useState('');
  // Load Tally embed script
  useEffect(() => {
    const existingScript = document.querySelector('script[src="https://tally.so/widgets/embed.js"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://tally.so/widgets/embed.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);
  const openEarlyAccessForm = () => {
    if (window.Tally) {
      window.Tally.openPopup('2E4rjD', {
        layout: 'modal',
        width: 700,
        autoClose: 5000
      });
    } else {
      // Fallback if script hasn't loaded yet
      window.open(EARLY_ACCESS_URL, '_blank');
    }
  };
  const handleUserSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (userPassword === USER_PASSWORD) {
      navigate('/home');
    } else {
      setUserError('Incorrect password. Please try again.');
      setUserPassword('');
    }
  };
  const handleInvestorSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (investorPassword === INVESTOR_PASSWORD) {
      navigate('/investor-deck');
    } else {
      setInvestorError('Incorrect password. Please try again.');
      setInvestorPassword('');
    }
  };
  const openInvestorModal = () => {
    setInvestorModal(true);
    setInvestorError('');
    setInvestorPassword('');
  };
  const openUserModal = () => {
    setUserModal(true);
    setUserError('');
    setUserPassword('');
  };
  const btnStyle = {
    boxShadow: '0 2px 6px 0 rgba(99,27,183,0.35)',
    width: '168px',
    backgroundColor: '#631bb7',
    border: 'none',
    cursor: 'pointer',
    fontSize: '13px',
    fontFamily: 'Inter, sans-serif',
    padding: '8px 12px',
    whiteSpace: 'nowrap' as const
  };
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-883">
      <div className="flex-grow flex items-center justify-center px-6 py-16" data-id="element-884">
        <div className="max-w-2xl mx-auto text-center w-full" data-id="element-885">
          {/* Logo */}
          <div className="mb-10" data-id="element-886">
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo Logo" className="h-10 md:h-12 mx-auto" data-id="element-887" />
          </div>

          {/* Coming Soon pill */}
          <button onClick={() => navigate('/home')} className="inline-flex items-center gap-1.5 border border-gray-200 text-gray-500 px-4 py-1.5 rounded-full text-sm font-medium mb-8 hover:border-gray-300 transition-colors" style={{
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
        }} data-id="element-888">
            <span data-id="element-889">Coming Soon</span>
            <span className="text-gray-400" data-id="element-890">›</span>
          </button>

          {/* Headline */}
          <h1 className="text-3xl md:text-4xl font-bold text-[#111111] leading-[1.1] tracking-tight mb-6" data-id="element-891">
            <div data-id="element-892">Bringing Digital Confidence</div>
            <div style={{
            color: '#631bb7'
          }} data-id="element-893">
              To Every Generation.
            </div>
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-gray-500 leading-relaxed mb-8 max-w-xl mx-auto" data-id="element-894">
            The first platform built from the ground up to simplify online
            safety while serving as your family's personal IT department.
          </p>

          {/* Social proof */}
          <div className="flex items-center justify-center gap-2 mb-8 flex-wrap" data-id="element-895">
            <div className="flex -space-x-1.5" data-id="element-896">
              <img src="https://cdn.magicpatterns.com/uploads/6giMtsG68yxp89aaHTtkX6/Screenshot_2026-02-22_at_12.56.48_AM.png" alt="Member" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-897" />
              <img src="https://cdn.magicpatterns.com/uploads/iaPLUAtSe7j7WSJaQUSv1g/Screenshot_2026-02-22_at_12.56.42_AM.png" alt="Member" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-898" />
              <img src="https://cdn.magicpatterns.com/uploads/hCu7TZEUwwQyaw75WuLKPE/Screenshot_2026-02-22_at_12.56.35_AM.png" alt="Member" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-899" />
              <img src="https://cdn.magicpatterns.com/uploads/wJ71gACjNWRRTKd8byxEK6/Screenshot_2026-02-22_at_12.51.11_AM.png" alt="Member" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-900" />
              <img src="https://cdn.magicpatterns.com/uploads/f2JgivSXHBCeH7uM5GKP7x/Screenshot_2026-02-22_at_12.55.40_AM.png" alt="Member" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-901" />
            </div>
            <p className="text-xs text-gray-500" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-902">
              Trusted by families who take digital security seriously.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col items-center gap-3" data-id="element-903">
            <button type="button" onClick={openEarlyAccessForm} className="text-white rounded-lg font-semibold no-underline transition-all flex items-center justify-center gap-1.5" style={btnStyle} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#8b4fd4'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#631bb7'} data-id="element-904">
              <ArrowRight size={13} data-id="element-905" />
              Get Early Access
            </button>

            <button type="button" onClick={openUserModal} className="text-white rounded-lg font-semibold transition-all flex items-center justify-center gap-1.5" style={btnStyle} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#8b4fd4'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#631bb7'} data-id="element-906">
              <User size={13} data-id="element-907" />
              User Log In
            </button>

            <button type="button" onClick={openInvestorModal} className="text-white rounded-lg font-semibold transition-all flex items-center justify-center gap-1.5" style={btnStyle} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#8b4fd4'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#631bb7'} data-id="element-908">
              <TrendingUp size={13} data-id="element-909" />
              Investor Log In
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="py-6 text-center text-sm text-gray-400" data-id="element-910">
        © 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.
      </div>

      <PasswordModal isOpen={userModal} onClose={() => setUserModal(false)} onSubmit={handleUserSubmit} title="User Access" description="Enter your password to continue." icon={<Lock size={22} color="#631bb7" data-id="element-912" />} error={userError} password={userPassword} onPasswordChange={val => {
      setUserPassword(val);
      setUserError('');
    }} data-id="element-911" />

      <PasswordModal isOpen={investorModal} onClose={() => setInvestorModal(false)} onSubmit={handleInvestorSubmit} title="Investor Access" description="Enter your password to view the investor deck." icon={<TrendingUp size={22} color="#631bb7" data-id="element-914" />} error={investorError} password={investorPassword} onPasswordChange={val => {
      setInvestorPassword(val);
      setInvestorError('');
    }} data-id="element-913" />
    </div>;
}